import { render, staticRenderFns } from "./index.vue?vue&type=template&id=56af4efd&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56af4efd')) {
      api.createRecord('56af4efd', component.options)
    } else {
      api.reload('56af4efd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=56af4efd&", function () {
      api.rerender('56af4efd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rate/index.vue"
export default component.exports